import { useState, memo, useRef } from 'react';
import useLockBodyScroll from 'hooks/useLockBodyScroll';
import useOnClickOutside from 'hooks/use-onClick-outside';
import Portal from 'hoc/Portal';
import useMemoSelector from 'hooks/useMemoSelector';

import { deviceParams } from 'store/reselect';

import { useImageStyles } from './styles';

const ImageModal = ({ value, onClose }) => {
  useLockBodyScroll();
  const imageRef = useRef();
  const [zoomed, setZoomed] = useState(false);
  const { deviceType } = useMemoSelector(deviceParams());

  const isMobile = deviceType === 'mobile';
  const { imageModal } = useImageStyles({ zoomed, isMobile });

  useOnClickOutside(imageRef, onClose);

  const toggleZoom = () => setZoomed(prev => !prev);

  return (
    <Portal>
      <div className={imageModal}>
        <div className="image-modal-content" style={{ position: 'relative' }}>
          <span className="icon-Close" onClick={onClose} />
          <div className="image-wrapper">
            <img
              ref={imageRef}
              src={value.url}
              alt={value.alt}
              title={value.title}
              onClick={toggleZoom}
              style={{
                transform: `scale(${zoomed ? 2 : 1})`,
              }}
              draggable={false}
            />
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default memo(ImageModal);
